import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
import { LanguageProvider } from "./i18n/LanguageContext";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles.scss";

ReactDOM.render(
  <Router>
    <LanguageProvider>
      <App />
    </LanguageProvider>
  </Router>,
  document.getElementById("root")
);
